import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { discoverySummary } from '@/mocks/discoverySocial';

export default function DiscoverySocialHero() {
  const navigate = useNavigate();

  return (
    <section className="relative w-full overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20social%20discovery%20visualization%20with%20interconnected%20glowing%20nodes%20and%20flowing%20gradient%20waves%2C%20vibrant%20coral%20amber%20and%20warm%20gold%20tones%20on%20dark%20background%2C%20modern%20tech-meets-community%20aesthetic%2C%20elegant%20curved%20lines%20forming%20network%20patterns%2C%20sophisticated%20data%20visualization%20art%2C%20ethereal%20glow%20effects%20with%20warm%20color%20palette%2C%20representing%20community%20discovery%20and%20social%20connection&width=1600&height=900&seq=disc-social-hero-2026&orientation=landscape"
        alt="Descubrí Comunidades"
        className="w-full h-[360px] md:h-[480px] object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      <div className="absolute inset-0 flex flex-col items-center justify-center px-4 text-center w-full">
        <div className="w-20 h-20 rounded-full bg-background-50/10 backdrop-blur-xl flex items-center justify-center mb-5 border border-background-50/15">
          <i className="ri-global-line text-4xl text-background-50"></i>
        </div>
        <h1 className="text-3xl md:text-5xl font-extrabold text-background-50 leading-tight mb-3">
          Descubrí Comunidades
        </h1>
        <p className="text-sm md:text-base text-background-50/80 max-w-xl leading-relaxed mb-6">
          Encontrá las radios, locutores, programas, eventos y concursos que están marcando tendencia ahora mismo. Tu próxima comunidad te espera.
        </p>

        {/* Summary Stats */}
        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-8">
          <div className="flex flex-col items-center">
            <span className="text-2xl md:text-3xl font-extrabold text-background-50">{discoverySummary.totalTrending}</span>
            <span className="text-xs text-background-50/70 font-medium">En Tendencia</span>
          </div>
          <div className="w-px h-8 bg-background-50/20 hidden md:block"></div>
          <div className="flex flex-col items-center">
            <span className="text-2xl md:text-3xl font-extrabold text-background-50">{discoverySummary.categoriesActive}</span>
            <span className="text-xs text-background-50/70 font-medium">Categorías Activas</span>
          </div>
          <div className="w-px h-8 bg-background-50/20 hidden md:block"></div>
          <div className="flex flex-col items-center">
            <span className="text-2xl md:text-3xl font-extrabold text-background-50">{(discoverySummary.totalFollowers / 1000000).toFixed(1)}M</span>
            <span className="text-xs text-background-50/70 font-medium">Seguidores</span>
          </div>
          <div className="w-px h-8 bg-background-50/20 hidden md:block"></div>
          <div className="flex flex-col items-center">
            <span className="text-2xl md:text-3xl font-extrabold text-background-50">+{discoverySummary.avgGrowthPercent}%</span>
            <span className="text-xs text-background-50/70 font-medium">Crecimiento Promedio</span>
          </div>
        </div>

        {/* CTA */}
        <button
          onClick={() => {
            const el = document.getElementById('discovery-feed');
            if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }}
          className="mt-8 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-50 text-foreground-950 font-bold text-sm whitespace-nowrap cursor-pointer hover:bg-background-100 transition-colors"
        >
          <i className="ri-arrow-down-line text-lg"></i>
          Explorar Tendencias
        </button>
      </div>
    </section>
  );
}